import React from 'react'

import Link from '@/components/link/link'
import { config } from '@/internal/config/config'

export const resolveImageAttribution = (
  author: string | null | undefined,
  customData: Record<string, unknown> | null | undefined
) => {
  if (author === null || author === undefined) return null
  let authored = <>{author}</>
  if (customData !== null && (customData?.unsplashAuthorUsername as string)) {
    const params = `utm_source=${config.app.unsplashAccount}&utm_medium=referral`
    authored = (
      <>
        <Link
          to={`https://unsplash.com/@${
            customData?.unsplashAuthorUsername as string
          }?${params}`}
        >
          {author}
        </Link>{' '}
        on <Link to={`https://unsplash.com/?${params}`}>Unsplash</Link>
      </>
    )
  }
  return authored
}
